export const SPAN_FOR_GRAPHQL = 'GQL';
export const SPAN_KIND_CLIENT = 3;
export const SPNA_ATTR_GQL_QUERY = 'query';
export const SPAN_ATTR_GQL_VARIABLES = 'variables';
export const SPAN_ATTR_GQL_BATCH = 'batch';

export const SPAN_TRACE_PARENT = 'traceparent';
